import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { HttpsRequestInterceptor } from './httpinterceptor';
import { DeepCloneInterceptor } from './deep-clone.interceptor';

@NgModule({
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpsRequestInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: DeepCloneInterceptor, multi: true }
    ]
})
export class InterceptorModule { }
